import React, { useContext } from "react";

type DetailsContextType = {
  open?: boolean;
  event?: Sentinel.Timeline.Event;
  onClose?: () => void;
  onOpen?: (event: Sentinel.Timeline.Event) => void;
};

const DetailsContext = React.createContext<DetailsContextType>({});

export const useDetailsContext = () => useContext(DetailsContext);

export default DetailsContext;
